import { createBaseFixtures } from "./base";
import { createFeatureFixtures } from "./feature";
import { createGambleFlows } from "./gambles";
import { createBonusHuntFixtures } from "./modes";
import { fsFixtureFreeSpins } from "./feature/fs_fixture_free_spins";
import type { ScriptedFixtureCatalog } from "@slot/game-shell";

/**
 * Simulated server catalog for the game's 2 features (ids = the server contract,
 * see feature/createFeaturePurchaseOffers.ts):
 * - featureFixturesById: per-PURCHASE sessions, routed by requestedFeatureIdentifier.
 * - baseFixturesByModeId: per-SPIN-MODE base pools, routed by requestedFeatureModeIdentifier.
 * Flat lists remain the fallbacks (no purchase id / no active mode).
 */
export function createFixtureCatalog(): ScriptedFixtureCatalog {
  return {
    baseFixtures: createBaseFixtures(),
    featureFixtures: createFeatureFixtures(),
    featureFixturesById: {
      super_bonus_buy: [fsFixtureFreeSpins()],
    },
    baseFixturesByModeId: {
      bonus_hunt_mode: createBonusHuntFixtures(),
    },
    gambleFlows: createGambleFlows(),
  };
}